export const mensajesInbox = {
  title: "الرسائل",

  noAccess: {
    description:
      "للوصول إلى صندوق الرسائل، يجب أن يكون رقم WhatsApp Business الخاص بك متصلاً من إعدادات الحساب.",
    connectButton: "ربط WhatsApp",
  },

  search: {
    placeholder: "ابحث بالهاتف أو باسم الضيف...",
  },

  filters: {
    allProperties: "كل العقارات",
    searchProperty: "ابحث عن عقار...",
    filterTitle: "تصفية الرسائل",
    clearAll: "مسح عوامل التصفية",
    removeOne: "إزالة «{filtro}»",
    someActive: "{count} عوامل تصفية",
  },

  tabs: {
    all: "الكل",
    unread: "غير المقروءة",
    pinned: "المثبّتة",
    archived: "المؤرشفة",
    noReservation: "بدون حجز",
    otaBooking: "Booking.com",
    otaAirbnb: "Airbnb",
    otaExpedia: "Expedia",
    otaOther: "OTA أخرى",
    unpaid: "غير مدفوعة",
    paid: "مدفوعة",
    arrivingSoon: "وصول قريب",
  },

  filterGroups: {
    chat: "المحادثة",
    origin: "المصدر",
    reservation: "الحجز",
  },

  list: {
    empty: "لا توجد محادثات",
    noMessages: "لا توجد رسائل",
  },

  channels: {
    web: "الويب",
    webConcierge: "كونسيرج الويب · بوابة الإقامة",
    otaMessage: "رسالة من {provider}",
  },

  chat: {
    placeholderSelect: "اختر محادثة للبدء",
    loading: "جارٍ تحميل المحادثة...",
    dropToAttach: "أفلت الملفات هنا لإرفاقها",
    emptyThread: "لا توجد رسائل بعد في هذه المحادثة",
    notSent: "لم تُرسَل",
    sending: "جارٍ الإرسال...",
  },

  sender: {
    guest: "الضيف",
    you: "أنت",
    aiAgent: "الوكيل الذكي",
  },

  media: {
    document: "مستند",
    sharedLocation: "موقع مشترك",
    attachment: "مرفق",
  },

  preview: {
    attachmentSent: "تم إرسال مرفق",
    messageSent: "تم إرسال رسالة",
    attachmentReceived: "تم استلام مرفق",
    newMessage: "رسالة جديدة",
  },

  mode: {
    aiAgent: "الوكيل الذكي",
    manual: "يدوي",
  },

  automation: {
    disabledNotice:
      "الوكيل الذكي غير مُفعّل لهذا العقار: لن يردّ، وأنت من يكتب الرسائل.",
    aiActiveBanner:
      "يردّ الوكيل الذكي على هذا الضيف تلقائيًا.",
  },

  faq: {
    title: "الأسئلة الشائعة",
  },

  composer: {
    placeholder: "اكتب رسالة أو استخدم / لإدراج ردٍّ...",
    hint: "Enter للإرسال · Shift+Enter لسطر جديد",
  },

  actions: {
    newConversation: "محادثة جديدة",
    options: "خيارات",
    attachFile: "إرفاق ملف",
  },

  alt: {
    flag: "العلم",
    sentImage: "صورة مُرسَلة",
  },

  common: {
    file: "ملف",
    notAvailable: "غير متاح",
  },

  nights: "{count} ليلة | {count} ليالٍ",

  arrival: {
    pending: "التاريخ غير محدد",
    today: "الوصول اليوم",
    tomorrow: "الوصول غدًا",
    yesterday: "وصل أمس",
    inDays: "بعد {count} يوم",
    daysAgo: "وصل قبل {count} يوم",
  },

  reservationStatus: {
    booked: "مؤكَّد",
    cancelled: "ملغى",
    pending: "قيد الانتظار",
    checked_in: "سجّل الوصول",
    checked_out: "سجّل المغادرة",
  },

  reservationPanel: {
    title: "الحجز المرتبط",
    stayEnded: "لم يعد الضيف مقيمًا",
    checkIn: "الوصول",
    checkOut: "المغادرة",
    room: "الغرفة",
    reservation: "الحجز",
    phone: "الهاتف",
    viewReservation: "عرض الحجز",
    noReservationTitle: "لا يوجد حجز مرتبط",
    noReservationOta:
      "وصلت هذه المحادثة من {channel} عبر Channex ولم تُربط بعد بحجز محلي.",
    noReservationWhatsapp:
      "راسل هذا الشخص رقم WhatsApp المتصل لكنه غير مرتبط بحجز بعد.",
    assignReservation: "ربط حجز",
    createReservation: "إنشاء حجز",
    assignExisting: "ربط حجز موجود",
    searchPlaceholder: "ابحث بالاسم أو الرمز...",
    noReservationsFound: "لم يُعثر على حجوزات",
    placeholderContext: "اختر محادثة لعرض السياق",
    propertyUnavailable: "العقار غير متاح",
  },

  contextMenu: {
    pin: "تثبيت المحادثة",
    unpin: "إلغاء تثبيت المحادثة",
    archive: "أرشفة المحادثة",
    unarchive: "إلغاء أرشفة المحادثة",
  },

  waStatus: {
    read: "تمت القراءة",
    delivered: "تم التسليم",
    queued: "في قائمة الانتظار",
    failed: "فشل",
    sent: "تم الإرسال",
  },

  waFailTitle: {
    noWhatsapp: "لا يوجد WhatsApp",
    invalidNumber: "رقم غير صالح",
    notSent: "لم تُرسَل",
  },

  waErrors: {
    generic: "تعذّر إرسال هذه الرسالة عبر WhatsApp.",
  },

  waErrorShort: {
    e131042: "مشكلة في الدفع على حساب WhatsApp",
    e131026: "لا يمكن للرقم استقبال WhatsApp",
    e131053: "تعذّر على WhatsApp تنزيل الملف",
    e132000: "بيانات ناقصة في القالب",
    e131009: "الرسالة لا تستوفي متطلبات WhatsApp",
  },

  toasts: {
    aiActiveSwitchManual:
      "الوكيل الذكي مُفعّل. بدّل إلى الوضع اليدوي للرد.",
    pinned: "تم تثبيت المحادثة",
    unpinned: "تم إلغاء تثبيت المحادثة",
    archived: "تمت أرشفة المحادثة",
    unarchived: "تم إلغاء أرشفة المحادثة",
    reservationAssigned: "تم ربط الحجز: {name}",
    reservationUnassigned: "تم إلغاء ربط الحجز",
    selectPropertyToCreate:
      "اختر عقارًا لإنشاء الحجز من هذه المحادثة.",
    userNotResolved: "تعذّر تحديد مستخدم اللوحة.",
    aiNotEnabledConfig:
      "لا يتوفّر الوكيل الذكي لهذا العقار. فعّله من إعدادات القائمة.",
    aiEnabledForChat: "تم تفعيل الوكيل الذكي لهذه المحادثة",
    manualEnabledForChat: "تم تفعيل الوضع اليدوي لهذه المحادثة",
    templateSent: "تم إرسال القالب بنجاح.",
  },

  errors: {
    inboxNotActive:
      "صندوق الرسائل غير مُفعّل لهذا الحساب، أو ما زال يلزم ربط WhatsApp للأعمال.",
    openConversation: "تعذّر فتح المحادثة",
    sendMessage: "تعذّر إرسال الرسالة. تحقّق من اتصال WhatsApp.",
    pin: "خطأ في تثبيت المحادثة",
    archive: "خطأ في الأرشفة",
    loadReservations: "خطأ في تحميل الحجوزات",
    assignReservation: "خطأ في ربط الحجز",
    unassignReservation: "خطأ في إلغاء ربط الحجز",
    updateMode: "تعذّر تحديث وضع هذه المحادثة",
    reactivationTemplate: "تعذّر إرسال قالب إعادة التنشيط.",
  },
};
